// @flow
// Actions
import type { Country } from '../../entities';
import * as environment from '../../environment';

export type Locale = 'es' | 'en';

type LocaleAction = {
  +type: string;
  +locale: Locale;
  +country?: Country;
};

export type LocaleState = {
  +locale: Locale;
  // +countryLocale?: Locale;
  +country?: Country;
  // writtable
  domainCountry?: Country;
};

// Actions
const CHANGE_LOCALE_REQUEST = 'CHANGE_LOCALE_REQUEST';
const CHANGE_DOMAIN_COUNTRY = 'CHANGE_DOMAIN_COUNTRY';

export const VALID_LOCALES = ['es', 'en'];
export const DEFAULT_LOCALE = 'es';

// Here we hardcode domain country just in case of development
export function initializeDevDomainCountry(env: string, node_env: ?string) {
  if (env !== 'production' && node_env !== 'production') {
    initialState.domainCountry = 'PE';
  }
}

// Action Creators
export function changeLocale(locale: Locale): LocaleAction {
  return {
    type: CHANGE_LOCALE_REQUEST,
    locale,
  };
}

export function setDomainCountry(country: Country) {
  return {
    type: CHANGE_DOMAIN_COUNTRY,
    country,
  };
}

export const actions = {
  CHANGE_LOCALE_REQUEST,
  CHANGE_DOMAIN_COUNTRY,
  changeLocale,
  setDomainCountry,
};

export const initialState: LocaleState = { locale: 'es' };

initializeDevDomainCountry(environment.env, process.env.NODE_ENV);

// Reducer
export default function reducer(state: LocaleState = initialState,
                                action: LocaleAction): LocaleState {
  switch (action.type) {
    case CHANGE_LOCALE_REQUEST:
      return {
        ...state,
        locale: action.locale,
      };
    case CHANGE_DOMAIN_COUNTRY:
      return {
        ...state,
        domainCountry: action.country,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/locale/duck.js